import React from "react";
import { IPagination } from "app/types";

export interface NotificationAction {
  label: string;
  variant: "primary" | "secondary";
}

// NotificationBadge removed

export interface NotificationItem {
  id: string;
  icon: React.ComponentType<any>;
  title: string;
  time: string;
  description: string;
  type: "ticket" | "release" | "sprint" | "team" | "project" | "calendar";
  isUnread?: boolean;
  iconColor?: string;
  bgClass?: string;
  actions?: NotificationAction[];
  isArchived?: boolean;
  meta?: any;
  eventType: string;
}

export interface NotificationTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export interface NotificationDescriptionProps {
  description: string;
  meta?: any;
  eventType: string;
}

export interface NotificationListSerialization {
  _id: string;
  userId: string;
  eventId: string;
  isRead: boolean;
  isArchived: boolean;
  type: string;
  category: string;
  actorUserId?: string;
  context: {
    description: string;
    ticketId: string;
    ticketTitle: string;
    [key: string]: string;
  };
  isCritical: boolean;
  createdAt: string;
}

export interface NotificationState {
  notifications: NotificationItem[];
  activeTab: string;
  loading: boolean;
  filteredNotifications: NotificationItem[];
  error?: any;
  isNotificationsLoading: boolean;
  notificationsPagination: IPagination;
  notificationCount: number;
  isNotificationCountLoading: boolean;
  reportTimeTickets: ReportTimeTicket[];
  ticketsPagination: IPagination;
  reportTimeSearchTerm: string;
  reportTimeShowDropdown: boolean;
  reportTimeSelectedTicketIds: string[];
  reportTimeTimes: { [ticketId: string]: string };
  sprintRetrospectiveStrongPoint: string;
  sprintRetrospectiveFailedPoint: string;
  dayOffType: string;
  dayOffComment: string;
  isMuted: boolean;
  muteDuration: string | null;
}

export interface ReportTimeTicket {
  id: string;
  title: string;
  type: string;
  icon?: React.ComponentType<any>;
}

export enum DayOffTypeEnum {
  FORCE_MAJEURE = "force_majeure",
  NATIONAL_HOLIDAY = "national_holiday",
  SICK_DAY = "sick_day",
  UNPLANNED_LEAVE = "unplanned_leave",
  VACATION = "vacation",
}

export enum NotificationMuteDurationEnum {
  THIRTY_MINUTES = "30_MINUTES",
  ONE_HOUR = "1_HOUR",
  FOUR_HOURS = "4_HOURS",
  UNTIL_TOMORROW = "UNTIL_TOMORROW",
  UNTIL_NEXT_WEEK = "UNTIL_NEXT_WEEK",
  FOREVER = "FOREVER",
}

export enum NotificationReadStatusEnum {
  READ = "read",
  UNREAD = "unread",
}

export const NotificationMuteDurationLabels: Record<
  NotificationMuteDurationEnum,
  string
> = {
  [NotificationMuteDurationEnum.THIRTY_MINUTES]: "For 30 minutes",
  [NotificationMuteDurationEnum.ONE_HOUR]: "For 1 hour",
  [NotificationMuteDurationEnum.FOUR_HOURS]: "For 4 hours",
  [NotificationMuteDurationEnum.UNTIL_TOMORROW]: "Until tomorrow",
  [NotificationMuteDurationEnum.UNTIL_NEXT_WEEK]: "Until next week",
  [NotificationMuteDurationEnum.FOREVER]: "Forever",
};
